import { Image, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
	certIcons: {
		display: 'flex',
		gap: '16px',
		marginTop: '10px',
		justifyContent: 'center',
		alignItems: 'center',

		'@media (min-width: 600px)': {
			justifyContent: 'flex-start',
		}
	},
	centered: {
		'@media (min-width: 600px)': {
			justifyContent: 'center',
		}
	},

	certImage: {
		width: '96px',
		height: '96px',
		objectFit: 'contain',

		/* improves scaling quality in most browsers */
		imageRendering: 'auto',

		/* avoids blurring from transform/layout scaling */
		transform: 'translateZ(0)'
	}
});

const Certifications = (props: { centered?: boolean }) => {
	const styles = useStyles();

	return (
		<div className={`${styles.certIcons} ${props.centered ? styles.centered : ''}`}>
			<Image
				src="/img/logos/iso9001.png"
				alt="ISO 9001 Certification"
				className={styles.certImage}
				loading="lazy"
				fetchPriority="low"
			/>

			<Image
				src="/img/logos/iso27001.png"
				alt="ISO 27001 Certification"
				className={styles.certImage}
				loading="lazy"
				fetchPriority="low"
			/>
		</div>
	);
};

export default Certifications;